import React from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
// import { COMMON_PAGE } from '../services/Macro'
import '../css/privacy.policy.css'

/** 页面通用常量 */
export const COMMON_PAGE = {
    MIN_AGE: 18,
    EMAIL: 'eeye@qq.com',
    ADDRESS: [
        `深圳市南山区西丽街道松坪山社区朗山路11号同方信息港F栋1701`
    ],
    ADDRESS_CN: [
        `深圳市南山区西丽街道松坪山社区朗山路11号同方信息港F栋1701`
    ],
    ADDRESS_EN: [
        `1701, Building F, Tongfang Information Port, No. 11 Langshan Road, Songpingshan Community, Xili Street, Nanshan District, Shenzhen`
    ],
    PHONE: '0755-86182366',
    LAST_UPDATE: '2025.05.20',
    CORPARATE_NAME: '深圳贝特莱电子科技股份有限公司',
    STATE_NAME: 'California. USA',
}

class ContactComponent extends React.Component<WithTranslation> {

    state = {
        email: COMMON_PAGE.EMAIL,
        address: COMMON_PAGE.ADDRESS,
        addressCn: COMMON_PAGE.ADDRESS_CN,
        addressEn: COMMON_PAGE.ADDRESS_EN,
        phone: COMMON_PAGE.PHONE,
        lastUpdate: COMMON_PAGE.LAST_UPDATE,
    }

    render() {
        const { i18n, lan } = this.props as any
        if (lan) {
            if (lan == 'zh_CN') {
                return this.renderCn()
            }
            else {
                return this.renderEn()
            }
        }
        else {
            const lang = i18n.language
            if (lang == 'zh_CN') {
                return this.renderCn()
            }
            else {
                return this.renderEn()
            }
        }
    }

    renderCn() {
        return (
            <>
                <div>
                    <b>电子邮件：</b><text className='contact'>{this.state.email}</text>
                </div>
                <div>
                    <b>电话：</b><text className='contact'>{this.state.phone}</text>
                </div>
                <div>
                    <b>地址：</b><text className='contact'>{this.renderAddressCn()}</text>
                </div>
                {/* <div>
                    <b>最新更新：</b>{this.state.lastUpdate}
                </div> */}
            </>
        )
    }

    renderEn() {
        return (
            <>
                <div>
                    <b>Email: </b><text className='contact'>{this.state.email}</text>
                </div>
                <div>
                    <b>Phone: </b><text className='contact'>{this.state.phone}</text>
                </div>
                <div>
                    <b>Address: </b><text className='contact'>{this.renderAddressEn()}</text>
                </div>
            </>
        )
    }

    renderAddressCn() {
        return (
            <>
                {this.state.addressCn.map((item, index) => (
                    <div>{item}</div>
                ))}
            </>
        )
    }

    renderAddressEn() {
        return (
            <>
                {this.state.addressEn.map((item, index) => (
                    <div>{item}</div>
                ))}
            </>
        )
    }
}

export const ContactComp1 = withTranslation()(ContactComponent)